import format from "comma-number";
import useSWR from "swr";
import { apiUrl } from "~/config";
import fetcher from "~/lib/fetcher";

/**
 * A post's view count, under its title. It comes from `apiUrl`, the same host the blog index
 * reads, so the two agree.
 */
export function ViewCounter({ blogUrl, slug }) {
  const { data } = useSWR(`${apiUrl}/api/${blogUrl}/${blogUrl}/${slug}`, fetcher);
  const views = data?.total;
  return <>{views != null ? format(views) : "–––"} views</>;
}
